<section class="header" [class.header--onboarding]="headerVariant === 'onboarding'">
    <ng-container *ngIf="headerVariant === 'default'">
        <div class="flex flex-row-reverse justify-content-between">
            <div class="header__actions">
                <div
                    class="header__notifications-container"
                    *ngIf="isLoggedIn"
                    [class.is-panel-open]="isNotificationsPanelOpen"
                >
                    <span
                        class="header__notifications-wrapper cursor-pointer"
                        [class.has-new]="hasNewNotifications$ | async"
                        [class.is-open]="isNotificationsPanelOpen"
                        (click)="onNotificationsClick($event)"
                    >
                        <img
                            [src]="isNotificationsPanelOpen ? 'assets/icons/ico_notifications.svg' : 'assets/icons/ico_notificaciones_default.svg'"
                            width="32"
                            height="32"
                            class="header__notifications"
                            alt="Notificaciones"
                        />
                    </span>
                    <app-notifications-panel
                        *ngIf="isNotificationsPanelOpen"
                        class="header__notifications-panel"
                        [notifications]="notifications$ | async"
                        [hasError]="notificationsHasError$ | async"
                        (notificationClick)="onNotificationSelected($event)"
                        (viewPreviousClick)="onViewPreviousNotifications()"
                        (markAllAsReadClick)="onMarkAllNotificationsAsRead()"
                    ></app-notifications-panel>
                </div>
                <div
                    class="header__profile-menu-container"
                    *ngIf="isLoggedIn"
                    [class.is-panel-open]="isProfileMenuPanelOpen"
                >
                    <span
                        class="header__profile-menu-wrapper cursor-pointer"
                        [class.is-open]="isProfileMenuPanelOpen"
                        (click)="onProfileMenuClick($event)"
                    >
                        <img
                            [src]="isProfileMenuPanelOpen ? 'assets/icons/ico_profile_active.svg' : 'assets/icons/ico_profile.svg'"
                            width="32"
                            height="32"
                            class="header__profile-menu-trigger"
                            alt="Perfil"
                        />
                    </span>
                    <app-profile-menu-panel
                        *ngIf="isProfileMenuPanelOpen"
                        class="header__profile-menu-panel"
                        (actionClick)="handleProfileMenuAction($event)"
                    ></app-profile-menu-panel>
                </div>
            </div>

            <div (click)="goToHome()" class="cursor-pointer">
                <img src="assets/images/criptococosbcp.svg" width="191" class="header__logo" alt="">
            </div>
        </div>

        <app-stepper></app-stepper>
    </ng-container>

    <ng-container *ngIf="headerVariant === 'onboarding'">
        <div
            class="header__onboarding-logo-wrapper cursor-pointer"
            role="link"
            tabindex="0"
            aria-label="Ir al inicio"
            (click)="goToOnboardingRoot()"
            (keydown)="onOnboardingLogoKeydown($event)"
        >
            <img
                src="assets/icons/logo_onboarding_header.svg"
                alt="CriptoCocos - La billetera cripto del BCP"
                class="header__onboarding-logo"
            />
        </div>
    </ng-container>
</section>

<app-notifications-modal
    *ngIf="isLoggedIn"
    [isOpen]="isNotificationsModalOpen"
    [notifications]="notifications$ | async"
    (closeModal)="closeNotificationsModal()"
    (notificationClick)="onNotificationSelected($event)"
></app-notifications-modal>
